export default __webpack_public_path__ + "static/media/user_guide_for_ESBN.77e2d1ce.pdf";